import { useState } from 'react';
import type { JSX, ReactNode } from 'react';
import './console.css';
import { SERVIZI, contaStati } from './data/servizi.ts';
import type { Vista } from './data/navigazione.ts';

export type { Vista };

interface Props {
  /** navigazione già composta dal chiamante — vedi ConsoleNav.tsx. Non più
   *  costruita qui: le 17 voci (documento "13 aree e pannelli di lavoro")
   *  vivono in data/navigazione.ts, non in questo file. */
  nav: ReactNode;
  /** riusato solo dal badge "richiedono attenzione" in testata, per tornare
   *  allo Stato piattaforma. */
  onVista: (v: Vista) => void;
  children: ReactNode;
}

export function ConsoleLayout({ nav, onVista, children }: Props): JSX.Element {
  const [ambiente, setAmbiente] = useState<'staging' | 'produzione'>('staging');
  const conta = contaStati(SERVIZI);

  return (
    <div className="uc">
      <header className="uc-hdr">
        <div className="uc-marchio">
          <div className="uc-globo" aria-hidden="true"><span /><span /></div>
          <span className="uc-wordmark">Uran<i>IA</i> <small>PA</small></span>
        </div>

        {/* Selettore di ambiente: se governi due impianti devi sapere sempre
            dove stai agendo. Non rimuoverlo per "semplificare la testata". */}
        <div className="uc-ambiente" role="group" aria-label="Ambiente">
          {(['staging', 'produzione'] as const).map((a) => (
            <button
              key={a}
              type="button"
              className={ambiente === a ? 'attivo' : undefined}
              aria-pressed={ambiente === a}
              onClick={() => { setAmbiente(a); }}
            >
              {a === 'staging' ? 'Staging' : 'Produzione'}
            </button>
          ))}
        </div>

        <input className="uc-cerca" type="search" placeholder="Cerca un servizio, un corpus, un atto…" />

        <div className="uc-utente">
          <button
            type="button"
            className="uc-btn secondario"
            style={{ border: 'none', background: 'transparent', color: 'var(--uc-rosso-testo)' }}
            onClick={() => { onVista('stato'); }}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 19, height: 19, borderRadius: '50%', background: 'var(--uc-rosso)', color: '#fff', font: '700 11px inherit', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {conta.bloccante + conta.sorveglianza}
              </span>
              richiedono attenzione
            </span>
          </button>
          <span className="uc-avatar" aria-hidden="true">AD</span>
          <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
            <span style={{ fontSize: 12.5, fontWeight: 600 }}>admin@staging</span>
            <span style={{ fontSize: 11, color: 'var(--uc-ink-3)' }}>Platform Admin</span>
          </span>
        </div>
      </header>

      <div className="uc-corpo">
        {nav}

        <div className="uc-vista">
          {children}

          {/* Obbligo informativo AI Act: presente in OGNI vista, non solo al login. */}
          <div className="uc-aiact">
            <span className="tag">AI ACT</span>
            <p>
              UranIA PA è un sistema basato su intelligenza artificiale ai sensi del Reg. UE 2024/1689
              (art. 50) e della L. 132/2025. Le risposte sono assistite da modelli linguistici: verifica
              sempre la base giuridica e le fonti citate prima di assumere decisioni amministrative.{' '}
              <a href="/trasparenza-ia">Normativa</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
